export interface ActiveCard {
  name: string;
  active: boolean;
  credits: number;
}
